var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BoxNotification.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8c87c712\",\"hasScoped\":false}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BoxNotification.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue/checkout/components/molecules/BoxNotification.vue
// module id = 194
// module chunks = 2